import {
  HistoriqueCommandeMaterielDto,
  ICommandeMaterielWebServiceClient
} from '@resources/resources';
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, Router} from "@angular/router";

@Injectable()
export class HistoriqueResolver implements Resolve<HistoriqueCommandeMaterielDto[]> {

  constructor(private commandeWebService: ICommandeMaterielWebServiceClient, private router: Router) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    
    let commandes = this.commandeWebService.searchCommandeHistorics();
    return commandes;
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/historique/historique.resolver.ts